// Firebase.tsx
import { initializeApp } from "firebase/app";
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBqeFOCVZfmfOqM0aMFsESYuKUpBCLVkLY",
    authDomain: "beyondcode-70c30.firebaseapp.com",
    projectId: "beyondcode-70c30",
    storageBucket: "beyondcode-70c30.appspot.com",
    messagingSenderId: "751029928365",
    appId: "1:751029928365:web:9df79853d432cabcb32124",
    measurementId: "G-KL9MF81ZML"
};

export const firebaseApp = initializeApp(firebaseConfig);
export const storage = getStorage(firebaseApp);
export const auth = getAuth(firebaseApp);
export const firestore = getFirestore(firebaseApp);